import { render, staticRenderFns } from "./homeDashboardContractDevelopment.vue?vue&type=template&id=70d2ddbf&scoped=true"
import script from "./homeDashboardContractDevelopment.vue?vue&type=script&lang=js"
export * from "./homeDashboardContractDevelopment.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardContractDevelopment.vue?vue&type=style&index=0&id=70d2ddbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2ddbf",
  null
  
)

export default component.exports